export default __webpack_public_path__ + "static/media/shazamColor.38da526a.svg";